import React, { Component } from "react";
import i18n from "../i18n";

class MaintenancePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentTime: new Date().toLocaleTimeString(),
    };
  }

  componentDidMount() {
    this.timer = setInterval(() => {
      this.setState({
        currentTime: new Date().toLocaleTimeString(),
      });
    }, 1000);
  }

  componentWillUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  render() {
    const { logoSrc } = this.props;

    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <div style={styles.logoContainer}>
            {logoSrc ? (
              <img
                src={logoSrc || "/placeholder.svg"}
                alt="ILUMEK Logo"
                style={styles.logo}
              />
            ) : (
              <div style={styles.iconContainer}>
                <img
                  width={200}
                  src="/img/logo_ilumek.png"
                  alt="Logo de Ilumek Service"
                ></img>
              </div>
            )}
          </div>

          <h1 style={styles.title}>{i18n.t("mainteinance.title")}</h1>

          <div style={styles.divider}></div>

          <p style={styles.message}>{i18n.t("mainteinance.message")}</p>

          <span style={styles.availabilty}>
            {i18n.t("mainteinance.availability")}
          </span>

          {/* {estimatedTime && (
            <p style={styles.estimatedTime}>
              Tiempo estimado de finalización: {estimatedTime}
            </p>
          )} */}

          <div style={styles.footer}>
            <p style={styles.currentTime}>
              {i18n.t("mainteinance.time")} {this.state.currentTime}
            </p>
          </div>
        </div>
      </div>
    );
  }
}

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100dvh",
    backgroundColor: "#1f2d3d",
    padding: "20px",
    fontFamily: "Arial, sans-serif",
    overflow: "hidden",
  },
  card: {
    backgroundColor: "#fff",
    borderRadius: "8px",
    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.3)",
    padding: "40px",
    maxWidth: "600px",
    width: "100%",
    textAlign: "center",
    marginBottom: "100px",
  },
  logoContainer: {
    marginBottom: "30px",
  },
  logo: {
    maxWidth: "200px",
    maxHeight: "80px",
  },
  logoPlaceholder: {
    width: "200px",
    height: "80px",
    margin: "0 auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#1f2d3d",
    borderRadius: "4px",
  },
  logoText: {
    color: "#fff",
    fontSize: "24px",
    fontWeight: "bold",
  },
  title: {
    color: "#1f2d3d",
    fontSize: "28px",
    margin: "0 0 20px 0",
  },
  divider: {
    height: "4px",
    width: "60px",
    backgroundColor: "#f89c11",
    margin: "0 auto 30px auto",
    borderRadius: "2px",
  },
  message: {
    color: "#1f2d3d",
    fontSize: "16px",
    lineHeight: "1.6",
    marginBottom: "20px",
  },
  estimatedTime: {
    color: "#1f2d3d",
    fontSize: "14px",
    fontWeight: "bold",
    marginBottom: "30px",
  },
  iconContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginLeft: "-10px",
  },
  footer: {
    marginTop: "30px",
    paddingTop: "20px",
    borderTop: "1px solid #eee",
  },
  currentTime: {
    color: "#1f2d3d",
    fontSize: "14px",
    margin: 0,
  },
  availabilty: {
    fontWeight: "bold",
  },
};

export default MaintenancePage;
